import React, { useState } from 'react';
import { 
    Youtube, Instagram, Facebook, Linkedin, Twitter, MessageCircle, 
    Globe, ChevronRight, X, Zap, Users, Award, Sparkles 
} from 'lucide-react';
import styles from './communityPage.module.css';
import Footer from "./Footer";

const communities = [
    {
        id: 'youtube',
        title: 'YouTube Channels',
        icon: <Youtube />,
        description: 'Watch structured video lectures, chapter-wise playlists, and live revision sessions for your exams.',
        channels: [
            { name: 'PrrepX Pathshala Official', link: 'https://www.youtube.com/@prepxpathshala' },
            { name: 'Target JEE & NEET - PrrepX Pathshala', link: '#' },
            { name: 'Class 11-12(Board & Foundation) - PrrepX Pathshala', link: '#' },
            { name: 'Class 9-10(Board & Olympiad) - PrrepX Pathshala', link: '#' },
            { name: 'Class 6-8(School & Olympiad) - PrrepX Pathshala', link: '#' },
            { name: 'Interviews - PrrepX Pathshala', link: '#' },
        ],
        accent: '#FF0000',
        action: 'See Channels'
    },
    {
        id: 'instagram',
        title: 'Instagram Page',
        icon: <Instagram />,
        description: 'Follow us for daily micro-learning content, memory hacks, and student life updates.',
        joinLink: 'https://instagram.com/prepxpathshala',
        accent: '#E1306C',
        action: 'Visit Page'
    },
    {
        id: 'facebook',
        title: 'Facebook Page',
        icon: <Facebook />,
        description: 'Connect with our main community for peer-to-peer discussions and resource sharing.',
        joinLink: '#',
        accent: '#1877F2',
        action: 'Visit Page'
    },
    {
        id: 'linkedin',
        title: 'LinkedIn Page',
        icon: <Linkedin />,
        description: 'Professional guidance and networking with IIT/NIT alumni and expert educators.',
        joinLink: '#',
        accent: '#0A66C2',
        action: 'Visit Page'
    },
    {
        id: 'twitter',
        title: 'Twitter Page',
        icon: <Twitter />,
        description: 'Stay updated with the fastest official news, exam alerts, and announcements.',
        joinLink: '#',
        accent: '#000000',
        action: 'Visit Page'
    },
    {
        id: 'whatsapp',
        title: 'WhatsApp Group',
        icon: <MessageCircle />,
        description: 'Get instant alerts for class schedules and quick academic support on your mobile.',
        joinLink: '#',
        accent: '#25D366',
        action: 'Join Group'
    },
];

export default function CommunityPage() {
    const [activeModal, setActiveModal] = useState(null);

    const handleAction = (item) => {
        if (item.channels) {
            setActiveModal(item);
        } else {
            window.open(item.joinLink, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <div className={styles.wrapper}>
            {/* --- Slim Premium Header --- */}
            <header className={styles.header}>
                <div className={styles.container}>
                    <div className={styles.badge}>
                        <Globe size={13} /> <span>Official Community Hub</span>
                    </div>
                    <h1 className={styles.mainTitle}>
                        Join PrrepX <span className={styles.gradientText}>Community Pages</span>
                    </h1>
                    <p className={styles.leadText}>
                        Your specialized gateway to expert support and peer learning across every platform.
                    </p>

                    {/* --- Value Proposition Bar (No Numbers) --- */}
                    <div className={styles.statsRow}>
                        <div className={styles.statItem}>
                            <div className={styles.statIcon}><Zap size={16} /></div>
                            <span>Instant Updates</span>
                        </div>
                        <div className={styles.statDivider}></div>
                        <div className={styles.statItem}>
                            <div className={styles.statIcon}><Users size={16} /></div>
                            <span>Peer Learning</span>
                        </div>
                        <div className={styles.statDivider}></div>
                        <div className={styles.statItem}>
                            <div className={styles.statIcon}><Award size={16} /></div>
                            <span>Expert Mentorship</span>
                        </div>
                    </div>
                </div>
            </header>

            {/* --- Compact Grid --- */}
            <section className={styles.gridSection}>
                <div className={styles.container}>
                    <div className={styles.grid}>
                        {communities.map((item) => (
                            <div 
                                key={item.id} 
                                className={styles.card}
                                onClick={() => handleAction(item)}
                            >
                                <div className={styles.cardGlow} style={{ backgroundColor: item.accent }}></div>
                                <div className={styles.cardTop}>
                                    <div className={styles.iconBox} style={{ color: item.accent }}>
                                        {item.icon}
                                    </div>
                                    <h3 className={styles.cardTitle}>{item.title}</h3>
                                </div>
                                <p className={styles.cardDescription}>{item.description}</p>
                                <div className={styles.cardFooter}>
                                    <span style={{ color: item.accent }}>{item.action}</span>
                                    <ChevronRight size={16} style={{ color: item.accent }} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* --- Focused CTA --- */}
            <section className={styles.ctaBanner}>
                <div className={styles.container}>
                    <div className={styles.ctaContent}>
                        <div className={styles.ctaIconWrapper}>
                            <Sparkles fill="#FFD700" color="#FFD700" size={32} />
                        </div>
                        <h2>Start Your Success Journey</h2>
                        <p>Don't study alone. Join our YouTube community for free masterclasses and structured learning paths.</p>
                        <button 
                            className={styles.ctaButton}
                            onClick={() => window.open('https://youtube.com/@prepxpathshala', '_blank')}
                        >
                            Official Youtube Channel
                        </button>
                    </div>
                </div>
            </section>

            <Footer />

            {/* --- Modal --- */}
            {activeModal && (
                <div className={styles.overlay} onClick={() => setActiveModal(null)}>
                    <div className={styles.modal} onClick={e => e.stopPropagation()}>
                        <div className={styles.modalHeader}>
                            <h3>Our YouTube Channels</h3>
                            <button onClick={() => setActiveModal(null)} className={styles.closeBtn}><X size={20}/></button>
                        </div>
                        <div className={styles.modalList}>
                            {activeModal.channels.map(ch => (
                                <a key={ch.name} href={ch.link} target="_blank" rel="noreferrer" className={styles.linkItem}>
                                    {ch.name}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}